
export default function Validate(fieldName, fieldData) {

    const usernameRegex = new RegExp("^[a-z0-9-_]{4,20}$");
    const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-_+=(){}!@#\/\$%\^&\*:;.'\"])(?=\\S+$)(?=.{8,})");
    const nameRegex = new RegExp("^[a-zA-Z-_ ]{1,20}$");
    const descRegex = new RegExp("^[a-zA-Z1-9-_ ]{1,100}$");
    const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
    const phoneNumRegex = new RegExp("^[xX0-9-+()]{7,20}$");
    //const otpRegex = /^(0|[1-9]\d*)$/
    const otpRegex = new RegExp("^[0-9]{1,6}$");
    const onlyNumber = new RegExp("^[0-9]{1,5}$");
    const notStartWithZero = new RegExp("^((?!(0))[0-9]{1,5})$");
    const noDecimals = new RegExp(/^(0|[1-9]\d*)$/);
    if(fieldName === 'firstName' || fieldName === "lastName") {
        return nameRegex.test(fieldData);
    }
    if(fieldName === "textArea") {
        return descRegex.test(fieldData);
    }
    else if(fieldName === "userName") {
        return usernameRegex.test(fieldData);
    }
    else if(fieldName === 'password') {
        return strongRegex.test(fieldData);
    }
    else if(fieldName === 'email') {
        return emailRegex.test(fieldData);
    }
    else if(fieldName === 'phoneNumber') {
        return phoneNumRegex.test(fieldData);
    }
    else if(fieldName === 'zipCode') {
        var alloweduser = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_ ";
        var totcount = 0;
        for(var count = 0; count < fieldData.length; count++) {
            if(alloweduser.indexOf(fieldData.substring(count, count + 1)) == -1) {
                totcount++;
            }
        }
        if(totcount != 0) {
            return true;
        }
        return false;
    }

    if(fieldName === 'otp') {
        return otpRegex.test(fieldData);
    }
    if(fieldName === "number") {
        return onlyNumber.test(fieldData);
    }
    if(fieldName === "notStartWithZero") {
        return notStartWithZero.test(fieldData);
    }
    if(fieldName === "noDecimals") {
        return noDecimals.test(fieldData);
    }
}